<template>
  <div id="container">
    <div v-for="(element, i) in reactiveElements" :key="i">
      <div v-if="element.options.type === 'TEXT-INPUT'">
        <TextInput :textInput="element" :openModal="openModal"
          :onReferencedListItemValueRemoved="onReferencedListItemValueRemoved" :key="element.id + readOnly"
          :readOnly="readOnly"></TextInput>
      </div>
      <div v-if="element.options.type === 'LARGE-TEXT-INPUT'">
        <LargeTextInput :largeTextInput="element" :openModal="openModal"
          :onReferencedListItemValueRemoved="onReferencedListItemValueRemoved" :key="element.id + readOnly"
          :readOnly="readOnly"></LargeTextInput>
      </div>
      <div v-if="element.options.type === 'CHECKBOX'">
        <Checkbox :element="element" :openModal="openModal"
          :onReferencedListItemValueRemoved="onReferencedListItemValueRemoved" :key="element.id + readOnly"
          :maxAnswers="maxAnswers" :readOnly="readOnly"></Checkbox>
      </div>
      <div v-if="element.options.type === 'GO-BACK'">
        <GoBack :goBack="element" :key="element.id" :onClickBackButton="onClickBackButton"></GoBack>
      </div>
      <div v-if="element.options.type === 'SELECT-INPUT'">
        <SelectInput :selectInput="element" :openModal="openModal"
          :onReferencedListItemValueRemoved="onReferencedListItemValueRemoved" :key="element.id + readOnly"
          :readOnly="readOnly"></SelectInput>
      </div>
      <div v-if="element.options.type === 'SLIDER'">
        <Slider :slider="element" :openModal="openModal"
          :onReferencedListItemValueRemoved="onReferencedListItemValueRemoved" :key="element.id + readOnly"
          :readOnly="readOnly"></Slider>
      </div>
      <div v-if="element.options.type === 'CALENDAR'">
        <EventModal v-if="showModal" :showModal="showModal" :eventData="currentEvent" :mode="mode"
          v-on:add:event="createEvent" v-on:update:event="updateEvent" v-on:cancel:add:event="cancelEvent"
          v-on:cancel:update:event="cancelUpdateEvent" />
        <Calendar :calendar="element" :openEventModal="openEventModal" :answers="events" :moveEvent="moveEvent"
          :durationChangeEvent="durationChangeEvent" :key="element.id" :showHintMessage="showHintMessage"
          :hideHintMessage="hideHintMessage" startTime="1" endTime="24"></Calendar>
      </div>
      <div v-if="element.options.type === 'TEXTAREA'">
        <TextArea :textarea="element" :key="element.id"></TextArea>
      </div>
      <div v-if="element.options.type === 'DATE-PICKER'">
        <Datepicker :datepicker="element" :openModal="openModal"
          :onReferencedListItemValueRemoved="onReferencedListItemValueRemoved" :key="element.id + readOnly"
          :readOnly="readOnly"></Datepicker>
      </div>
      <div v-if="element.options.type === 'LIST-INPUT'">
        <ListInput :listInput="element" :key="element.id + readOnly" :readOnly="readOnly" />
      </div>
      <div v-if="
        element.options.type === 'SUMMARY' &&
        element.dependency?.[0].options.type === 'CHECKBOX'
      ">
        <!-- <pre>{{ formatSummaryElement(element) }}</pre> -->
        <Checkbox :element="formatSummaryElement(element)" :openModal="openModal"
          :onReferencedListItemValueRemoved="onReferencedListItemValueRemoved" :key="element.id + readOnly"
          :maxAnswers="maxAnswers" :readOnly="true"></Checkbox>
      </div>
      <div v-if="
        element.options.type === 'SUMMARY' &&
        element.dependency?.[0].options.type === 'SLIDER'
      ">
        <Slider :slider="formatSummaryElement(element)" :openModal="openModal"
          :onReferencedListItemValueRemoved="onReferencedListItemValueRemoved" :key="element.id + readOnly"
          :readOnly="true"></Slider>
      </div>
      <div v-if="
        element.options.type === 'SUMMARY' &&
        element.dependency?.[0].options.type === 'LIST-INPUT'
      ">
        <ListInput :listInput="formatSummaryElement(element)" :key="element.id + readOnly" :readOnly="true"></ListInput>
      </div>
      <div v-if="
        element.options.type === 'SUMMARY' &&
        element.dependency?.[0].options.type === 'SELECT-INPUT'
      ">
        <SelectInput :selectInput="formatSummaryElement(element)" :key="element.id + readOnly" :readOnly="true">
        </SelectInput>
      </div>
      <div v-if="
        element.options.type === 'SUMMARY' &&
        element.dependency?.[0].options.type === 'TEXT-INPUT'
      ">
        <TextInput :textInput="formatSummaryElement(element)" :openModal="openModal"
          :onReferencedListItemValueRemoved="onReferencedListItemValueRemoved" :key="element.id + readOnly"
          :readOnly="true"></TextInput>
      </div>
      <div v-if="
        element.options.type === 'SUMMARY' &&
        element.dependency?.[0].options.type === 'LARGE-TEXT-INPUT'
      ">
        <LargeTextInput :largeTextInput="formatSummaryElement(element)" :openModal="openModal"
          :onReferencedListItemValueRemoved="onReferencedListItemValueRemoved" :key="element.id + readOnly"
          :readOnly="true"></LargeTextInput>
      </div>
      <div v-if="
        element.options.type === 'SUMMARY' &&
        element.dependency?.[0].options.type === 'DATE-PICKER'
      ">
        <Datepicker :datepicker="formatSummaryElement(element)" :openModal="openModal"
          :onReferencedListItemValueRemoved="onReferencedListItemValueRemoved" :key="element.id + readOnly"
          :readOnly="true"></Datepicker>
      </div>
    </div>
  </div>
</template>

<script>
import { Options, Vue } from "vue-class-component";
import "@Moodbuster2.0/mb2-components-vue/dist/mb2-components-vue.css";
import _ from "lodash";
import moment from "moment";
import { uuid } from "vue-uuid";
import {
  Calendar,
  Checkbox,
  Datepicker,
  GoBack,
  LargeTextInput,
  ListInput,
  SelectInput,
  Slider,
  TextArea,
  TextInput
} from "@Moodbuster2.0/mb2-components-vue";
import EventModal from "../components/EventModal";
import { useStore } from "vuex";
import { wrapper } from "../utils/wrapper";
import ApiService from "../services/ApiService";
import StorageService from "@/services/StorageService";

import { formatDate, addMissingKeys, formatTimeSeriesEventForUpdateApi, formatEventForApi, formatEventForUpdateApi, fixTimeZone } from "@/utils/events";

@Options({
  components: {
    Checkbox,
    Datepicker,
    GoBack,
    LargeTextInput,
    ListInput,
    SelectInput,
    Slider,
    TextArea,
    TextInput,
    EventModal,
    Calendar
  },
  props: {
    elements: Array,
    moveToPage: Function,
    readOnly: Boolean
  },
  provide: {
    /**
     * Function called to update an element's answer
     */
    onAnswerUpdate(element, newAnswer) {
      element.Answer = newAnswer;
    }
  }
})
export default class Elements extends Vue {
  data() {
    return {
      globalStore: useStore(),
      apiService: new ApiService(),
      showModal: false,
      mode: "add",
      currentEvent: {},
      events: [],
      user: null,
      // eslint-disable-next-line no-undef
      storageService: new StorageService(),
      pageId: Number(this.$route.params.pageId)
    };
  }

  // Format iframe element
  mounted() {
    const iframes = document.getElementsByTagName('iframe')
    if (iframes.length > 0) {
      for (const iframe of iframes) {
        iframe.style.width = '95%'
        iframe.style.margin = 'auto'
      }
    }
    const images = document.querySelectorAll('#elements-container img')
    if (images.length > 0) {
      for (const image of images) {
        image.style.maxWidth = '100%'
      }
    }
  }

  // Formats summary element so that the answer to the dependency is used as the initial value (tested with LIST-INPUT, SELECT-INPUT, TEXT-INPUT, LARGE-TEXT-INPUT, DATE-PICKER)
  // This was just a quick fix. The SUMMARY component should be implemented in the components_vue repo (see Moodbuster2.0/client/components_vue#43).
  formatSummaryElement(element) {
    let auxElement = Object.assign({}, element);
    const parsedDependencyAnswers = auxElement.dependencyAnswers.map(
      answer => ({ value: JSON.parse(answer.value) })
    );

    if (auxElement.dependency?.[0].options.type === "SLIDER") {
      if (auxElement.dependency[0].refs?.[0]?.pageElement) {
        auxElement.dependency[0].ref =
          auxElement.dependency[0].refs[0].pageElement;
        auxElement.dependency[0].ref.Answer = _.cloneDeep(
          auxElement.dependency[0].ref.answers
        );

        if (
          !Array.isArray(
            auxElement.dependency[0].refs[0].pageElement.answers[0].value
          )
        ) {
          const parsedRefAnswers = JSON.parse(
            auxElement.dependency[0].refs[0].pageElement.answers[0].value
          );
          auxElement.dependency[0].ref.Answer[0].value = parsedRefAnswers;
        }
      }
      auxElement = auxElement.dependency[0];
    }

    if (auxElement.dependency?.[0].options.type === "CHECKBOX") {
      auxElement = auxElement.dependency[0];
      auxElement.Answer = parsedDependencyAnswers;
    } else {
      auxElement.Answer = parsedDependencyAnswers;
      if (auxElement.Answer?.length == 0) auxElement.Answer = [{value: []}];
      auxElement.options.data = auxElement.Answer[0].value;
    }
    if (auxElement.dependency?.[0].options.type === "LIST-INPUT") {
      auxElement.Answer = auxElement.Answer[0];
    }

    auxElement.required = false;

    return auxElement;
  }

  // Runs when maximum answers is reached
  maxAnswers(number) {
    this.globalStore.commit("open", {
      type: "warning",
      text: this.$t(
        "ALERTS.MODULE_PAGE.CHECKBOX_OPTIONS_LIMITATION.FAILED.TEXT",
        {
          number: number
        }
      )
    });
  }

  //move to page
  async onClickBackButton(pageId, pageStateId) {
    this.moveToPage(pageId, pageStateId);
  }

  // Runs when the page is created
  async created() {
    this.user = this.storageService.getUser();
    await this.getEvents();
  }

  // drag and drop calendar event to move
  async moveEvent(event) {
    event = addMissingKeys(event)
    await this.updateEvent({ data: event, fixTimeZone: false });
  }
  // method called when the event is resized
  async durationChangeEvent(event) {
    event = addMissingKeys(event.event)
    await this.updateEvent({ data: event, fixTimeZone: false });
  }
  /*
    Gets the events from the API.
    Data transformation is done to comply with the format required by vue-cal.
  */
  async getEvents() {
    const processedEvents = [];

    const dataResponse = await wrapper(
      this.apiService.getEvents(this.user.patientsId)
    );
    if (dataResponse.error) {
      console.error("get events error ", dataResponse.error);
      this.globalStore.commit("open", {
        type: "danger",
        title: this.$t("ALERTS.EVENTS.GET.FAILED.TITLE"),
        text: this.$t("ALERTS.EVENTS.GET.FAILED.TEXT")
      });
    }

    if (dataResponse.data) {
      for (const e of dataResponse.data) {
        processedEvents.push(this.formatEventForVueCal(e));
      }
    }

    this.events = processedEvents;
  }

  moveHintBox(x, y) {
    const d = document.querySelector(".box");
    d.style.left = x + "px";
    d.style.top = y - d.offsetHeight + "px";
  }
  resetHintBox() {
    const d = document.querySelector(".box");
    d.style.left = "50%";
    d.style.top = "50%";
  }

  async showHintMessage() {
    this.globalStore.commit("open", {
      type: "info",
      text: this.$t("SCHEDULE.HINT_MESSAGE")
    });
    onmousemove = e => {
      this.moveHintBox(e.clientX, e.clientY);
    };
    onmousedown = () => {
      this.hideHintMessage();
    };
  }

  async hideHintMessage() {
    this.globalStore.commit("close", {
      type: "info",
      text: this.$t("SCHEDULE.HINT_MESSAGE")
    });
    onmousemove = null;
    onmousedown = null;
    this.resetHintBox();
  }

  // Formats event to be used by vue-cal
  // the event attribute complies with the format returned by the API
  formatEventForVueCal(event) {
    // Helps handling events without end time from the old portal. It will assume the event is one hour long by adding one hour to the start time.
    let end = event.endsAt;
    if (!end) {
      end = new Date(event.startsAt);
      end.setTime(end.getTime() + 1 * 60 * 60 * 1000);
    }

    return {
      ...event,
      daysCount: 1,
      end: formatDate(end),
      split: null,
      start: formatDate(event.startsAt),
      class: event.color?.name,
      content: event.description || event.content,
      uuid: event.uuid || uuid.v4(),
      resizable: !event.completed
    };
  }

  // Removes event from the events array
  removeEvent(uuid) {
    this.events = _.filter(this.events, e => e.uuid !== uuid);
  }
  // click and hold calendar event to delete
  async deleteEvent(event) {
    this.removeEvent(event.uuid);

    const response = await wrapper(
      this.apiService.deleteEvent(event.id, this.user.patientsId)
    );

    if (response.error) {
      console.error("delete events error ", response.error);
      this.globalStore.commit("open", {
        type: "danger",
        title: this.$t("ALERTS.EVENTS.DELETE.FAILED.TITLE"),
        text: this.$t("ALERTS.EVENTS.DELETE.FAILED.TEXT")
      });
      // restores the event on the calendar events array
      this.events.push(event);
    }

    // event got deleted
  }
  // method called after closing without save 'update event' modal
  cancelUpdateEvent() {
    this.showModal = false;
  }
  // method called after closing without save 'add new event' modal
  cancelEvent(data) {
    this.showModal = false;
    this.removeEvent(data.uuid);
  }
  // method called after closing 'update event' modal
  async updateEvent({ data, fixTimeZoneValue }) {
    if (data.data) data = data.data;
    if (data.id) {
      if (this.showModal) {
        this.showModal = false;
      }

      let event = formatEventForUpdateApi(data);

      const timeSeries = await wrapper(this.apiService.getTimeSeries(this.user.patientsId, event.id))
      if (timeSeries.data.some((obj) => obj.id == event.id)) {
        event.rrule = { "timeSeriesId": `${timeSeries.data[0].rrule.timeSeriesId}` }
      }

      if (fixTimeZoneValue) event = fixTimeZone(event);

      if (data.applyRange.range == null || data.applyRange.range == 'current') {
        // Update only this event
        if (data.toDelete.toDelete) {
          event.uuid = data.uuid;
          this.deleteEvent(event)
        } else {
          const eventSent = await wrapper(
            this.apiService.updateEvent(event.id, event, this.user.patientsId)
          );

          if (eventSent.error) {
            this.globalStore.commit("open", {
              type: "danger",
              title: this.$t("ALERTS.EVENTS.UPDATE.FAILED.TITLE"),
              text: this.$t("ALERTS.EVENTS.UPDATE.FAILED.TEXT")
            });
          }
          // event got updated
          if (eventSent.data) {
            event.uuid = data.uuid;
            this.updateEventsArray(event);
          }
        }
      } else {
        // Update all events in the timeSeries
        if (data.toDelete.toDelete) {
          await this.deleteTimeSeries(timeSeries.data)
        }
        else {
          // Edit all events in the series
          const timeSeriesUuid = uuid.v4()
          for (const singleEvent of timeSeries.data) {
            const updatedEvent = formatTimeSeriesEventForUpdateApi(singleEvent, data, timeSeriesUuid)

            const result = await wrapper(this.apiService.updateEvent(updatedEvent.id, updatedEvent, this.user.patientsId))
            if (result.error) {
              this.globalStore.commit("open", {
                type: "danger",
                title: this.$t("ALERTS.EVENTS.UPDATE_TIMESERIES.FAILED.TITLE"),
                text: this.$t("ALERTS.EVENTS.UPDATE_TIMESERIES.FAILED.TEXT")
              });
            }
          }
          this.events = []
          await this.getEvents()
        }
      }
    }
  }

  async deleteTimeSeries(timeSeries) {
    for (const singleEvent of timeSeries) {
      const result = await wrapper(this.apiService.deleteEvent(singleEvent.id, this.user.patientsId))
      if (result.error) {
        this.globalStore.commit("open", {
          type: "danger",
          title: this.$t("ALERTS.EVENTS.DELETE_ALL.FAILED.TITLE"),
          text: this.$t("ALERTS.EVENTS.DELETE_ALL.FAILED.TEXT")
        });
      }
      this.removeEvent(this.events.find(event => event.id == singleEvent.id).uuid)
    }
  }

  // sync local events array after server changes are completed
  updateEventsArray(data) {
    const index = this.getEvent(data.uuid);
    const formattedData = this.formatEventForVueCal(data);

    this.events[index].title = formattedData.title;
    this.events[index].content = formattedData.content;
    this.events[index].class = formattedData.class || data.color;
    this.events[index].id = formattedData.id;
    this.events[index].start = formattedData.start;
    this.events[index].end = formattedData.end;
    this.events[index].allDay = formattedData.allDay;
    this.events[index].completed = formattedData.completed;
    this.events[index].resizable = !data.completed;

  }

  // Return event form the events array
  getEvent(uuid) {
    return _.findIndex(this.events, e => e.uuid === uuid);
  }

  // method called after closing 'add new event' modal
  async createEvent(data) {
    this.showModal = false;
    const events = formatEventForApi(data, this.user.language);
    for (let event of events) {
      event = fixTimeZone(event);

      const eventSent = await wrapper(
        this.apiService.createEvent(event, this.user.patientsId)
      );

      if (eventSent.error) {
        this.globalStore.commit("open", {
          type: "danger",
          title: this.$t("ALERTS.EVENTS.CREATE.FAILED.TITLE"),
          text: this.$t("ALERTS.EVENTS.CREATE.FAILED.TEXT")
        });
        this.removeEvent(data.uuid);
      }
      if (eventSent.data) {
        event.uuid = data.uuid;
        event.id = eventSent.data.id;
        this.updateEventsArray(event);
        this.updateLocalAnswer(event);
      }
    }
    await this.getEvents()
  }
  /*
    Updates the element's answer locally to pass required validation.
    */
  updateLocalAnswer(event) {
    const calendar = this.elements.filter(
      e => e.id === event.pagesElementsId || e.id === event.templatesElementsId
    );
    if (calendar && calendar[0] && calendar[0].Answer) {
      calendar[0].Answer.push(event);
    }
  }
  /*
    Opens the event modal.
    Note when the update is called the type parameter is an object and does not contain the string 'update'
  */
  async openEventModal(event, type) {
    setTimeout(async () => {
      // Adding a uuid to the event that is stored in the events array
      // eases the process of finding the event in the events array
      if (!event.uuid) {
        event.uuid = uuid.v4();
      }

      this.resetCurrent();

      this.currentEvent.uuid = event.uuid;
      this.currentEvent.end = event.end;
      this.currentEvent.start = event.start;
      this.currentEvent.allDay = event.allDay;
      this.currentEvent.pagesElementsId = event.pagesElementsId;
      this.currentEvent.templatesElementsId = event.templatesElementsId;

      if (typeof type == "string" && type == "add") {
        this.mode = "add";
        if (event.title) {
          this.currentEvent.title = event.title;
        }
        this.events.push(event);
      } else {
        this.mode = "update";
        this.currentEvent.id = event.id;
        this.currentEvent.title = event.title;
        this.currentEvent.color = event.class;
        this.currentEvent.content = event.content;
        this.currentEvent.completed = event.completed;
        // when the event is completed then the event cannot be edited
        this.currentEvent.editable = !event.completed;
        this.currentEvent.resizable = !event.completed;
        // when the event has an associated answer then the event cannot be deleted
        this.currentEvent.hasAnswer = (await this.checkAnswerExists(event)) ? true : false;
      }
      this.showModal = true;
    }, 200);

    return event;
  }

  async checkAnswerExists(event) {
    const result = await wrapper(this.apiService.checkEventAnswer(event.id, this.user.patientsId))
    if (result.data.error) return true
    else return result.data.data
  }

  // Reset the currentEvent
  resetCurrent() {
    this.currentEvent = {
      id: null,
      uuid: "",
      title: "",
      description: "",
      start: "",
      end: "",
      allDay: false,
      completed: false,
      color: "",
      content: "",
      editable: true,
      resizable: true,
      pagesElementsId: null,
      templatesElementsId: null
    };
  }
  /**
   * Function fired when the user presses the delete button of a list input on a reference card.
   */
  async onReferencedListItemValueRemoved(listItemElement, removedUuid) {
    let index;

    listItemElement.Answer?.forEach(answer => {
      answer.value?.forEach((value, i) => {
        if (value.uuid == removedUuid) {
          index = i;
        }
      });
    });

    await this.deleteAnswer(listItemElement, removedUuid, index);
  }
  async deleteAnswer(listItemElement, removedUuid, index) {
    const dataResponse = await wrapper(
      this.apiService.deleteAnswer(
        this.user.patientsId,
        listItemElement.id,
        index
      )
    );

    if (dataResponse.error) {
      if (
        dataResponse.error.response.data &&
        dataResponse.error.response.data.error &&
        dataResponse.error.response.data.error.code ==
        "AUTHORIZATION_ERROR_ONE_ELEMENT"
      ) {
        this.globalStore.commit("open", {
          type: "danger",
          text: this.$t("ALERTS.MODULE_PAGE.DELETE_SINGLE_ANSWER.FAILED.TEXT")
        });
      } else {
        this.globalStore.commit("open", {
          type: "danger",
          title: this.$t("ALERTS.MODULE_PAGE.DELETE_ANSWER.FAILED.TITLE"),
          text: this.$t("ALERTS.MODULE_PAGE.DELETE_ANSWER.FAILED.TEXT")
        });
      }
    } else {
      const answers = [];
      listItemElement.Answer?.forEach(refAnswer => {
        answers.push({
          ...refAnswer,
          value: refAnswer.value.filter(v => v.uuid !== removedUuid)
        });
      });
      listItemElement.Answer = answers;
    }
  }
  openModal({ type, isConfirmation, onConfirm, onCancel }) {
    this.globalStore.commit("open", {
      type,
      title: this.$t("ALERTS.CONFIRMATION.TITLE"),
      text: this.$t("ALERTS.CONFIRMATION.TEXT"),
      isConfirmation,
      onConfirm,
      onCancel
    });
  }

  parseStringToNumber(conditionalElement, conditionalValue, valueToBeCompared) {
    // Select, slider and checkbox inputs retrieve strings instead of numbers, in this case we need to convert it to number
    if (
      conditionalElement.options.type === "SELECT-INPUT" ||
      conditionalElement.options.type === "SLIDER" ||
      conditionalElement.options.type === "CHECKBOX"
    ) {
      if (valueToBeCompared) {
        valueToBeCompared = parseInt(valueToBeCompared);
      } else {
        conditionalValue = parseInt(conditionalValue);
      }
    } else if (conditionalElement.options.type === "TEXT-INPUT") {
      if (
        conditionalElement.options.typeInput &&
        conditionalElement.options.typeInput === "number"
      ) {
        if (valueToBeCompared) {
          valueToBeCompared = parseInt(valueToBeCompared);
        } else {
          conditionalValue = parseInt(conditionalValue);
        }
      }
    }
    return { conditionalValue, valueToBeCompared };
  }
  
  filterConditionalElements(srcElement, conditionalElement) {
    let conditionalValue = srcElement.options.conditionalOptions.value;

    if (typeof conditionalValue === "string" && !isNaN(conditionalValue)) {
      conditionalValue = this.parseStringToNumber(
        conditionalElement,
        conditionalValue
      ).conditionalValue;
    }

    if (conditionalElement.Answer) {
      let valueToBeCompared = conditionalElement.Answer?.[0]?.value;

      if (typeof valueToBeCompared === "string" && !isNaN(valueToBeCompared)) {
        valueToBeCompared = this.parseStringToNumber(
          conditionalElement,
          conditionalValue,
          valueToBeCompared
        ).valueToBeCompared;
      }

      if (typeof valueToBeCompared === "object") {
        valueToBeCompared = Object.values(valueToBeCompared);
      }

      switch (srcElement.options.conditionalOptions.comparator) {
        case "gte":
          if (
            typeof valueToBeCompared === "number" &&
            valueToBeCompared >= conditionalValue
          ) {
            return true;
          } // We can't have any value lt conditionalValue and need at least a value that is gte than the conditionalValue
          else if (
            typeof valueToBeCompared === "object" &&
            !valueToBeCompared.some(x => x < conditionalValue) &&
            valueToBeCompared.some(x => x >= conditionalValue)
          ) {
            return true;
          } else {
            return false;
          }
        case "gt":
          if (
            typeof valueToBeCompared === "number" &&
            valueToBeCompared > conditionalValue
          ) {
            return true;
          } // We can't have any value lte conditionalValue and need at least a value that is gt than the conditionalValue
          else if (
            typeof valueToBeCompared === "object" &&
            !valueToBeCompared.some(x => x <= conditionalValue) &&
            valueToBeCompared.some(x => x > conditionalValue)
          ) {
            return true;
          } else {
            return false;
          }
        case "eq":
          if (
            typeof valueToBeCompared === "number" &&
            valueToBeCompared == conditionalValue
          ) {
            return true;
          } else if (
            typeof valueToBeCompared === "object" &&
            valueToBeCompared.includes(conditionalValue)
          ) {
            return true;
          } else if (
            typeof valueToBeCompared === "string" &&
            valueToBeCompared == conditionalValue
          ) {
            return true;
          }
          {
            return false;
          }
        case "lt":
          if (
            typeof valueToBeCompared === "number" &&
            valueToBeCompared < conditionalValue
          ) {
            return true;
          } // We can't have any value gte conditionalValue and need at least a value that is lt than the conditionalValue
          else if (
            typeof valueToBeCompared === "object" &&
            !valueToBeCompared.some(x => x >= conditionalValue) &&
            valueToBeCompared.some(x => x < conditionalValue)
          ) {
            return true;
          } else {
            return false;
          }
        case "lte":
          if (
            typeof valueToBeCompared === "number" &&
            valueToBeCompared <= conditionalValue
          ) {
            return true;
          }
          // We can't have any value gt the conditionalValue and need at least a value that is lte than the conditionalValue
          else if (
            typeof valueToBeCompared === "object" &&
            !valueToBeCompared.some(x => x > conditionalValue) &&
            valueToBeCompared.some(x => x <= conditionalValue)
          ) {
            return true;
          } else {
            return false;
          }
        case "neq":
          if (
            typeof valueToBeCompared === "number" &&
            valueToBeCompared != conditionalValue
          ) {
            return true;
          } else if (
            typeof valueToBeCompared === "object" &&
            !valueToBeCompared.includes(conditionalValue)
          ) {
            return true;
          } else if (
            typeof valueToBeCompared === "string" &&
            valueToBeCompared != conditionalValue
          ) {
            return true;
          } else {
            return false;
          }
      }
    }
    return false;
  }

  get reactiveElements() {
    this.elements.forEach(element => {
      // updates conditional elements visibility
      if (element.options?.conditional) {
        let conditionalElement;
        if (!element.options.conditionalOptions.element) {
          conditionalElement = this.elements.find(
            otherElement =>
              otherElement.id == element.options?.conditionalOptions?.elemId
          );
        } else {
          conditionalElement = element.options.conditionalOptions.element;
        }

        if (conditionalElement) {
          element.visible = this.filterConditionalElements(
            element,
            conditionalElement
          );
        }
      }
      if (element.options.type == 'CALENDAR') {
        if (element.options.data == '') {
          element.options.data = this.$t("EVENT_MODAL.DEFAULT_EVENT_NAME")
        }
      }
    });
    return this.elements;
  }
}
</script>

<style scoped lang="scss">
#container {
  text-align: left;
}

</style>
